import axiosInstance from '../services/AxiosInstance';

export const getMerchantBankAccounts = (getData) => {
  return axiosInstance.get("merchant-bank/list", {
    params: getData,
  });
};

export const getMerchantVirtualAccounts = (getData) => {
  return axiosInstance.get("merchant-bank/virtual-accounts", {
    params: getData,
  });
};

export const getMerchantBankAccountCount = (getData) => {
  return axiosInstance.get("merchant-bank/merchant-bank-count", {
    params: getData,
  });
};

export const addMerchantBankAccounts = (data) => {
  return axiosInstance.post("merchant-bank/create", data);
};

export const updateMerchantBankAccounts = (id, data) => {
  return axiosInstance.put(`merchant-bank/update/${id}`, data);
};

export const merchantsDocData = (id, data) => {
  return axiosInstance.get(`merchant-bank/merchant-details/${id}`, data);
};

export const fetchMerchantBankAccountsById = async (id) => {
    const response = await axiosInstance.get(`merchant-bank/show/${id}`);
    return response.data;
};
